import { t } from "i18next"
import * as Yup from "yup"

export const templateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required(t("global.name_is_required", "Name is required"))
    .min(2, t("global.name_must_be_atleast_two", "Name must be at least 2 characters")),
  description: Yup.string(),
  items: Yup.array()
})
